export function stripTags(input) {
    if (!input) return ""; // Handle null or undefined
    return input.replace(/<\/?[^>]+(>|$)/g, ""); // Removes all tags
  }
  